<template>
    <div>

        <div v-show="now.includes('KGS')" class="magsg">
            <InputNumber 
            size="small" style="width:60px;" v-model="kgs"></InputNumber>/KGS
        </div>
        <div v-show="now.includes('CBM')" class="magsg">
            <InputNumber size="small" style="width:60px;" v-model="cbm"></InputNumber>/CBM
        </div>
        <div v-show="now.includes('P/L')" class="magsg">
            <InputNumber size="small" style="width:60px;" v-model="pl"></InputNumber>/PL
        </div>

    </div>
</template>
<script>
import currency from "../baojia/currency.vue";
export default {
    props: ["bbb","now",],
    components: { currency },
    model: {
        prop: "bbb",
        event: "aaa",
    },
    data() {
        return {
            kgs: 0,
            cbm: 0,
            pl: 0,
        }
    },
    methods: {
        tt() {
            //console.log(this.bbb);
            eval('this.' + this.bbb);

        },
        rangeDanjia(a, b, c) {
            this.kgs = a;
            this.cbm = b;
            this.pl = c;
        },
        emit() {
            this.$emit('aaa', "rangeDanjia(" +
                this.kgs + "," +
                this.cbm + "," +
                this.pl+
                ")")
        }
    },
    mounted() {
        this.tt();
    },
    watch: {
        kgs(v) {
            this.emit();
        },
        cbm() {
            this.emit();
        },
        pl() {
            this.emit();
        },
        bbb() {
            this.tt();
        },
        now(){
           // var kgs=this.kgs,cbm=this.cbm,pl=this.pl,jian=this.jian;

            
            if (!this.now.includes('KGS')) {
                this.kgs=0;
            }
            if (!this.now.includes('CBM')) {
                this.cbm=0;
            }
            if (!this.now.includes('P/L')) {
                this.pl=0;
            }
            if (!this.now.includes('件')) {
                this.jian=0;
            }
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/wuliu/kehu/gongshi/rangeDanjia.vue